import { Grid, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Apartment, BarChart, Workspaces } from "@mui/icons-material";
import { DashboardCardGeneral } from "./components/DashboardCard/DashboardCardGeneral";
import { TemplateDefaultAdminConsole } from "../components/TemplateDefaultAdminConsole";
import { DashboardDataWorkspaceList } from "./components/DashboardDataWorkspaceList/DashboardDataWorkspaceList";
import { DashboardUpgradeBox } from "./components/DashboardUpgradeBox/DashboardUpgradeBox";
import { DashboardStoragePerUser } from "./components/DashboardStoragePerUser/DashboardStoragePerUser";
import { GetStorageSizeByOrgInternalName } from "../../../services/OrganizationServices";
import { useParams } from "react-router-dom";
import { StorageSizeInfoModel } from "../../../model/StorageSizeInfoModel";
import { KeyDriveDialog } from "../../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { useFreePlanDialog } from "../../../hooks/useFreePlanDialog";
import { DashboardCardOrganizationList } from "./components/DashboardDataWorkspaceList/DashboardCardOrganizationList";
import { KeyDriveTab2 } from "../../../components/KeydriveComponents/Tabs/KeydriveTab2";
import { KeyDriveTabPanel } from "../../../components/KeydriveComponents/Tabs/components/KeyDriveTabPanel";

export const DashboardAdmin = () => {
    const { nameOrg } = useParams();
    const [generalData, setGeneralData] = useState<StorageSizeInfoModel | null>(null);
    const [loadingGeneralData, setLoadingGeneralData] = useState(false);
    const { t } = useTranslation();
    const { shouldShowDialog, dialogProps } = useFreePlanDialog();
    const [tab, setTab] = useState<number>(0);

    useEffect(() => {
        if (!nameOrg) return;
        const fetchData = async () => {
            setLoadingGeneralData(true);

            try {
                const [generalData] = await Promise.all([
                    GetStorageSizeByOrgInternalName(nameOrg)
                ]);

                if (generalData) setGeneralData(generalData);
            } catch (err) {
                console.error('Erro ao carregar dados do dashboard:', err);
            } finally {
                setLoadingGeneralData(false);
            }
        };

        fetchData();
    }, [nameOrg]);

    if (shouldShowDialog) {
        return <KeyDriveDialog {...dialogProps} />;
    }

    return (
        <TemplateDefaultAdminConsole iconTitle={<BarChart />} title="Dashboard" subtitle={t('AdminConsole.DashboardSubtitle')}>
            <Grid container spacing={2} sx={{height: "100%"}}>
                <Grid item xs={12} md={6} lg={8} xl={9} sx={{height: 'calc(100% - 20px)'}}>
                    <DashboardCardGeneral 
                        loading={loadingGeneralData} 
                        data={generalData ? generalData : undefined}
                    />
                    <KeyDriveTab2
                        icon1={<Apartment />}
                        icon2={<Workspaces />}

                        label1={t("AdminConsole.Organizations")}
                        label2="Workspaces"
                        
                        onChange={(ev, i) => {
                            setTab(i);
                        }}
                    >   
                        <KeyDriveTabPanel
                            index={0}
                            value={tab}
                        >
                            <DashboardCardOrganizationList generalData={generalData!} />
                        </KeyDriveTabPanel>
                        <KeyDriveTabPanel
                            index={1}
                            value={tab}
                        >
                            <DashboardDataWorkspaceList />
                        </KeyDriveTabPanel>
                    </KeyDriveTab2>
                </Grid>
                <Grid item xs={12} md={6} lg={4} xl={3} sx={{height: '100%'}}>
                    <Box sx={{ border: '1px solid #EAEAEA', padding: '14px', height: '100%', minHeight: '580px' }}>
                        <DashboardStoragePerUser />
                        <DashboardUpgradeBox />
                    </Box>
                </Grid>
            </Grid>
        </TemplateDefaultAdminConsole>
    );
};